import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CatInputField } from '@blocks-react/components/InputField';
import { replaceTokensInString } from '@app/utils';

const FormField = ({
  fieldId,
  label,
  required = false,
  maxLength = '40',
  onBlur,
  customValidation,
  additional,
  enabled = true
}) => {
  const [t] = useTranslation();

  const {
    control,
    setValue,
    trigger,
    formState: { errors }
  } = useFormContext();

  const FIELD_REQUIRED_MSG = t('1626_FIELD_REQUIRED_ERROR');

  const onBlChange = e => {
    setValue(fieldId, e.detail.value);
    additional && additional();
  };

  const onFieldBlur = e => {
    trigger(fieldId);
    onBlur && onBlur(e);
  };

  const rules = customValidation
    ? {
        validate: { customValidation }
      }
    : {
        required: {
          value: required,
          message: replaceTokensInString(FIELD_REQUIRED_MSG, label)
        }
      };

  return (
    <Controller
      control={control}
      name={fieldId}
      rules={rules}
      render={({ field }) => (
        <CatInputField
          {...field}
          size="md"
          fieldId={fieldId}
          name={fieldId}
          data-testid={`input-${fieldId}`}
          label={label}
          required={required}
          maxLength={maxLength}
          onBlChange={onBlChange}
          status={errors?.[fieldId] ? 'error' : undefined}
          fieldNote={errors?.[fieldId] ? errors?.[fieldId]?.message : undefined}
          onBlur={onFieldBlur}
          enabled={enabled}
        />
      )}
    />
  );
};

FormField.propTypes = {
  fieldId: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  maxLength: PropTypes.string,
  onBlur: PropTypes.func,
  customValidation: PropTypes.func,
  additional: PropTypes.func,
  enabled: PropTypes.bool
};

export default FormField;
